import { CircularProgress, FormControl, MenuItem, Select } from "@mui/material";
import { useCountryList } from "../../../services/okta";
import { DatasetDropdownProps } from "./DatasetDropdown-interface";
import "./DatasetDropdown.scss";

const DatasetDropdownCampaign = ({
  value,
  onChange,
  disabled,
  countries: propCountries = [],
}: DatasetDropdownProps) => {
  const {
    data: dataCountries,
    isLoading: isLoadingCountries,
    isError: isErrorCountries,
  } = useCountryList();

  const countriesList = propCountries.length ? propCountries : dataCountries || [];

  const lowerValue = value?.toLowerCase();

  const selected =
    countriesList.find((country) =>
      [country.code, country.name]
        .filter(Boolean)
        .map((v) => v.toLowerCase())
        .includes(lowerValue)
    ) || null;

  const selectedValue = selected?.name || "";

  if (isLoadingCountries) return <CircularProgress size={24} />;
  if (isErrorCountries) return <div>Error loading countries</div>;
  if (countriesList.length === 0) return <div>No available countries</div>;

  return (
    <FormControl fullWidth disabled={disabled}>
      <Select
        value={selectedValue}
        onChange={onChange}
        displayEmpty
        MenuProps={{
          MenuListProps: { className: "dataset-dropdown-list" },
          PaperProps: { className: "dataset-dropdown" },
        }}
      >
        {countriesList.map((country) => (
          <MenuItem key={country.code} value={country.name} className="dataset-dropdown-item">
            {country.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DatasetDropdownCampaign;
